import { leaveTypeExportColumnId } from '@vacationtracker/shared/functions/export'

export const COLUMN_IDS = {
  select: 'select',
  name: 'name',
  team: 'team',
  location: 'location',
  role: 'role',
  labels: 'labels',
  status: 'status',
  startDate: 'startDate',
  email: 'email',
  employeeId: 'employeeId',
  birthday: 'birthday',
  actions: 'actions',
} as const

export const leaveTypeColumnId = (leaveTypeId: string, kind: 'quota' | 'balance'): string => leaveTypeExportColumnId(leaveTypeId, kind)

export const PROFILE_DEFAULT_ORDER = [
  COLUMN_IDS.team,
  COLUMN_IDS.location,
  COLUMN_IDS.role,
  COLUMN_IDS.labels,
  COLUMN_IDS.status,
  COLUMN_IDS.startDate,
  COLUMN_IDS.email,
  COLUMN_IDS.employeeId,
  COLUMN_IDS.birthday,
]

export const PROFILE_HIDDEN_BY_DEFAULT = [COLUMN_IDS.email, COLUMN_IDS.employeeId, COLUMN_IDS.birthday]

/** The i18n id naming a profile column, for the column-settings list. */
export function columnLabelId(columnId: string): string {
  switch (columnId) {
    case COLUMN_IDS.team:
      return 'app.department'
    case COLUMN_IDS.location:
      return 'app.location'
    case COLUMN_IDS.role:
      return 'app.users.role'
    case COLUMN_IDS.labels:
      return 'app.labels'
    case COLUMN_IDS.status:
      return 'app.status'
    case COLUMN_IDS.startDate:
      return 'users.startDate'
    case COLUMN_IDS.email:
      return 'app.email'
    case COLUMN_IDS.employeeId:
      return 'user.employeeId'
    case COLUMN_IDS.birthday:
      return 'user.birthday'
    default:
      return 'app.name'
  }
}
